/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ProcessingOptions } from './processingOptions';
import { Status } from './status';
import { TransactionStatusEnum } from './transactionStatusEnum';


export interface TransactionLog {
    id: string;
    direction?: string;
    smS_RouteName?: string;
    dateCreated: Date;
    isFromTelco: boolean;
    service?: string;
    serviceType?: string;
    serviceNumber?: string;
    serviceLogic?: string;
    operator?: string;
    module?: string;
    serviceCode?: string;
    msisdn?: string;
    partner?: string;
    prefix?: string;
    message?: string;
    messageType?: string;
    count: number;
    totalCost: number;
    rateCost: number;
    processingTime: number;
    status: Status;
    errorGroup?: string;
    errorCode?: string;
    errorText?: string;
    errorDescription?: string;
    isTest: boolean;
    duplicatedNumbersCount: number;
    destination?: string;
    originator?: string;
    serviceProviderName?: string;
    pages: number;
    processingOptions?: ProcessingOptions;
    referenceNumber?: string;
    creatorId?: string;
    senderId?: string;
    smSRouteName?: string;
    transactionNote?: string;
    smsmRoute?: string;
    transactionStatusValue: TransactionStatusEnum;
    transactionStatus?: string;
    anqLookUpClientId: number;
    priority: number;
    deliveryDate: Date;
    smsClientEmail?: string;
    smsClientFullname?: string;
    smsClientUsername?: string;
    smsClientStatus?: string;
}
